import { render, staticRenderFns } from "./DateTimeWidget.vue?vue&type=template&id=667b1b7c&scoped=true"
import script from "./DateTimeWidget.vue?vue&type=script&lang=js"
export * from "./DateTimeWidget.vue?vue&type=script&lang=js"
import style0 from "./DateTimeWidget.vue?vue&type=style&index=0&id=667b1b7c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "667b1b7c",
  null
  
)

export default component.exports